import {createFileRoute} from '@tanstack/react-router';

import Login from '@/anonymous/views/Login';

export const Route = createFileRoute('/(anonymous)/login')({
  component: Login
});
